import { defineComponent as _defineComponent } from 'vue'
import { deleteBatchHistory } from '@/apis/taskList'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import Vue from 'vue'
import { ref } from 'vue'

import mBatchHistoryItem from '../components/m-batch-history-item.vue'
import { BatchHistoryType } from '../types/batchHistory'
import mEmpty from './m-empty.vue'

interface PropsType {
  batchHistoryList: BatchHistoryType[]
  total: number
  isLoading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-history-list',
  props: {
    batchHistoryList: null,
    total: null,
    isLoading: { type: Boolean }
  },
  emits: ['onHistoryPageChange'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  batchHistoryList: BatchHistoryType[]
  total: number
  isLoading?: boolean
}




const currentHistoryPage = ref(1)
const isLoadingHistory = ref(false)
const warningModal = ref<any>()
const searchText = ref('')
const searchDate = ref<string[]>()

async function handleDeleteHistory(payload: { batch_ids: number[] }) {
  warningModal.value = Vue.prototype.$antdConfirm({
    title: translate('common.tip'),
    content: translate('taskPage.record.tipText'),
    okText: translate('common.confirm'),
    cancelText: translate('common.cancel'),
    centered: true,
    closable: true,
    onOk: async () => {
      warningModal.value.destroy()
      setTimeout(async () => {
        isLoadingHistory.value = true
        const res = await deleteBatchHistory(payload)
        isLoadingHistory.value = false
        if (res.status) {
          Vue.prototype.$message.success(translate('common.deleteSuccess'))
          const payload = dealSearchPayload()
          emits('onHistoryPageChange', currentHistoryPage.value, payload)
        } else {
          Vue.prototype.$message.error(translate('common.deleteFail'))
        }
      }, 300)
    },
  })
}

function handleHistoryChangePage(page: number) {
  currentHistoryPage.value = page
  emits('onHistoryPageChange', currentHistoryPage.value, dealSearchPayload())
}

function handleSelectDateRange(date: any, dateString: string[]) {
  searchDate.value = dateString
  handleSearchHistory()
  buryPointApi('task', 'task_time_filter')
}

function handleSearchHistory() {
  currentHistoryPage.value = 1
  emits('onHistoryPageChange', currentHistoryPage.value, dealSearchPayload())
  buryPointApi('task', 'task_search_history')
}

function dealSearchPayload() {
  const searchInfo = {}
  if (searchDate.value && searchDate.value[0]) {
    Object.assign(searchInfo, {
      time_start: searchDate.value[0],
      time_end: searchDate.value[1],
    })
  }
  if (searchText.value) {
    Object.assign(searchInfo, {
      task_batch: searchText.value,
    })
  }
  return searchInfo
}

function translateLang(key: string) {
  return translate(key)
}

expose({ handleHistoryChangePage })

return { __sfc: true,props, emits, currentHistoryPage, isLoadingHistory, warningModal, searchText, searchDate, handleDeleteHistory, handleHistoryChangePage, handleSelectDateRange, handleSearchHistory, dealSearchPayload, translateLang, mBatchHistoryItem, mEmpty }
}

})